<template>
	<pull-to
		:top-load-method="callback"
		@top-state-change="stateChange"
		:top-config="TOP_DEFAULT_CONFIG"
		:is-bottom-bounce="false"
		:is-top-bounce="isAtTopEl"
		:top-block-height="50"
		v-bind="$attrs"
		style="width: 100%"
		v-if="$store.getters.layout == 'Mobile'"
	>
		<template slot="top-block" slot-scope="props">
			<div class="top-load-wrapper">
				<svg
					v-if="props.state === 'pull'"
					height="30"
					viewBox="0 0 262 494"
					xmlns="http://www.w3.org/2000/svg"
					style="transform: rotate(180deg)"
				>
					<path d="M130.77 0L261.54 226.5H0L130.77 0Z" />
					<rect x="77" y="226" width="108" height="79" />
					<rect x="77" y="338" width="108" height="30" />
					<rect x="77" y="401" width="108" height="30" />
					<rect x="77" y="464" width="108" height="30" />
				</svg>

				<svg
					v-else-if="props.state === 'trigger'"
					height="30"
					viewBox="0 0 262 494"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path d="M130.77 0L261.54 226.5H0L130.77 0Z" />
					<rect x="77" y="226" width="108" height="79" />
					<rect x="77" y="338" width="108" height="30" />
					<rect x="77" y="401" width="108" height="30" />
					<rect x="77" y="464" width="108" height="30" />
				</svg>

				<loader
					v-else-if="props.state === 'loading'"
					:height="'25px'"
					:width="'25px'"
					:dark="true"
				/>

				<loader
					v-else-if="props.state === 'loaded-done'"
					:height="'25px'"
					:width="'25px'"
					:dark="true"
				/>
			</div>
		</template>
		<slot></slot>
	</pull-to>
	<div v-else>
		<slot></slot>
	</div>
</template>

<script>
import PullTo from "vue-pull-to";
export default {
	name: "",
	components: {
		PullTo,
	},
	props: {
		callback: {
			type: Function,
			required: true,
		},
		disable: {
			type: Boolean,
			required: false,
			default: false,
		},
		isPageWithoutHeader: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			iconLink: "",
			TOP_DEFAULT_CONFIG: {
				pullText: "Pull to refresh", // The text is displayed when you pull down
				triggerText: "Refreshing", // The text that appears when the trigger distance is pulled down
				loadingText: "Refreshing", // The text in the load
				doneText: "Done", // Load the finished text
				failText: "Error", // Load failed text
				loadedStayTime: 400, // Time to stay after loading ms
				stayDistance: 50, // Trigger the distance after the refresh
				triggerDistance: 70, // Pull down the trigger to trigger the distance
			},
			isAtTopEl: false,
		};
	},
	mounted() {
		let vm = this;
		if (vm.$store.getters.layout != "Mobile") return;
		vm.updateIsAtTopEl();
		window.addEventListener("scroll", vm.updateIsAtTopEl, { passive: true });
	},
	methods: {
		stateChange(state) {
			let vm = this;
			console.log(state);
			if (state === "pull" || state === "trigger") {
				this.toggleBg(true);
				this.iconLink = "#icon-arrow-bottom";
			} else if (state === "loading") {
				this.iconLink = "#icon-loading";
			} else if (state === "loaded-done") {
				this.toggleBg(false, vm.TOP_DEFAULT_CONFIG.loadedStayTime);
				this.iconLink = "#icon-finish";
			} else {
				this.toggleBg(false);
			}
		},
		toggleBg(active = false, delay = 0) {
			let vm = this;
			let cont = document.querySelector(".action-block-top");
			active
				? cont.classList.add("active")
				: setTimeout(() => cont.classList.remove("active"), delay);
		},
		updateIsAtTopEl() {
			let vm = this;
			const headerHeight =
				document.querySelector("header").getBoundingClientRect().height - 5;
			const mainElPosition = document
				.querySelector("main")
				.getBoundingClientRect().top;
			vm.isAtTopEl = vm.isPageWithoutHeader
				? mainElPosition >= 0 && !vm.disable
				: mainElPosition >= headerHeight && !vm.disable;
		},
	},
};
</script>

<style lang="scss">
.top-load-wrapper {
	line-height: 50px;
	text-align: center;
	padding: 10px 0;
	svg {
		fill: var(--light-black);
	}
}
.action-block-top.active {
	// background: var(--light-gray);
}
.icon-arrow {
	transition: 0.2s;
	transform: rotate(180deg);
}
.icon-loading {
	transform: rotate(0deg);
	animation-name: loading;
	animation-duration: 3s;
	animation-iteration-count: infinite;
	animation-direction: alternate;
}
@keyframes loading {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}
</style>
